// ** React Imports
import { useContext, useEffect, useRef } from "react";

import { Button } from "reactstrap";
import CustomTooltip from "@components/ui-components/tooltip";
// ** Custom Components
import Flex from "@components/ui-components/flex";
import ImageWrapper from "../image-wrapper";
import { ThemeContext } from "@context/theme";
// ** Third Party
import classnames from "classnames";
import { useTranslation } from "react-i18next";

const SideFilter = ({
    children,
    title = "Filters",
    desc = "Get Filtered Data",
    onSubmit,
    onReset,
    filterClass = "",
    btnClass = "",
    id = ""
}) => {
    const { handleFilterFocus, filterOpen } = useContext(ThemeContext);
    const wrapperRef = useRef(null);
    const { t } = useTranslation();

    const handleOnSubmit = (action) => {
        if (action === "submit") {
            onSubmit();
            handleFilterFocus();
        } else if (action === "reset") {
            onReset();
        }
    };

    const handleKeyDown = e => {
        if (e.key === "Enter") {
            onSubmit();
        }
    };
    const onKeyUp = event => {
        if (event.key === "/" && event.ctrlKey) {
            if (!filterOpen) {
                handleFilterFocus();
            }
        }
        if (event.key === "Escape") {
            if (filterOpen) {
                handleFilterFocus();
            }
        }
    };
    /* This is a useEffect hook that is listening for the keypress of the forward slash key. If the
       forward slash key is pressed, the modal will open. */
    useEffect(() => {
        window.addEventListener("keyup", onKeyUp);
        return () => {
            window.removeEventListener("keyup", onKeyUp);
        };
    }, [onKeyUp]);
    // /**
    //  * If the user clicks outside of the ref element, then set the open range to false.
    //  */
    // function useOutsideAlerter (ref) {
    //     useEffect(() => {
    //         function handleClickOutside (event) {
    //             if (ref.current && !ref.current.contains(event.target)) {
    //                 setIsOpen(false);
    //             }
    //         }
    //         document.addEventListener("mousedown", handleClickOutside);
    //         return () => {
    //             document.removeEventListener("mousedown", handleClickOutside);
    //         };
    //     }, [ref]);
    // }
    // useOutsideAlerter(wrapperRef);
    return (
        <>
            {" "}
            <Button
                color=""
                data-tour={`${id}-filter`}
                data-cy="filter-btn"
                className={classnames("custom-btn", { [btnClass]: btnClass })}
                onClick={handleFilterFocus}
                id="filter-btn">
                <Flex align="center" className="w-max">
                    <ImageWrapper
                        width={17}
                        id="filter"
                        src={"common/filter.svg"}/>{" "}
                    <span className="d-md-block d-none">
                        {t("Filters")}
                    </span>
                </Flex>
            </Button>
            <CustomTooltip target="filter-btn" content="(ctrl+/)" />
            <div
                onKeyDown={e => handleKeyDown(e)}
                ref={wrapperRef}
                className={classnames("filter-modal", {
                    open         : filterOpen,
                    [filterClass]: filterClass
                })}>
                {/* Filter header */}
                <div className="filter-header">
                    <div>
                        <h4 className="mb-0 fw-bolder" data-cy="filter-title">
                            {t(title)}
                        </h4>
                        <small className="m-0 fw-bold" data-cy="filter-desc">
                            {t(desc)}
                        </small>
                    </div>
                    <div
                        data-cy="filter-modal-close"
                        className="cursor-pointer  btn-icon btn d-flex align-items-center text-secondary"
                        onClick={handleFilterFocus}>
                        <i className="mdi mdi-close font-medium-5" />
                    </div>
                </div>

                {/* Filter Body */}
                <div className="filter-body">
                    <div className="content-body pb-5 px-1 pt-25 overflow-scroll h-100">
                        {children}
                    </div>
                    <div className="filter-footer">
                        <Button
                            data-cy="sidepanel-reset-btn"
                            onClick={() => handleOnSubmit("reset")}
                            className={classnames("me-75")}
                            color="primary"
                            outline>
                            {t("Clear")}
                        </Button>
                        <Button
                            data-cy="sidepanel-apply-btn"
                            onClick={() => handleOnSubmit("submit")}
                            className={classnames("me-75")}
                            color="primary">
                            {t("Apply")}
                        </Button>
                    </div>

                </div>
            </div>
        </>
    );
};

export default SideFilter;
